import * as React from 'react';
import { Modal } from 'antd';
import {
  PropsTypes,
  FuncTypes,
  ConstantTypes,
} from './SEBulkShipment.types';
import ExcelS3Upload from 'src/components/common/ExcelS3Upload/ExcelS3Upload';
import FailureArrayHandleRfq from 'src/components/common/FailureArrayHandleRfq';

const SEBulkShipmentHtml = (
  props: PropsTypes,
  state: any,
  constants: ConstantTypes,
  getFunctions: FuncTypes,
) => {
  const { headerTxt, fileType, isMultiple, accept, linkInfoText } = constants;
  const {
    handleDownloadLineItemsExcel,
    handleSubmit,
    handleClose,
    handlleFileData,
    handleErrorModal
  } = getFunctions;

  const { isLoading, errorData, isErrorModalVisible } = state;
  const { isVisible } = props;

  const failureArrayHtml = () => {
    if (!isErrorModalVisible) return null;
    return (
      <FailureArrayHandleRfq
        id={'row'}
        failureArray={errorData}
        isVisible={isErrorModalVisible}
        onModalClose={() => handleErrorModal(true)}
      ></FailureArrayHandleRfq>
    );
  };

  return (
    <Modal
      destroyOnClose
      visible={isVisible}
      title="Upload Shipment(s)"
      okText="Submit"
      onCancel={() => handleClose(false)}
      onOk={handleSubmit}
      confirmLoading={isLoading}
    >
      <ExcelS3Upload
        headerText={headerTxt}
        fileType={fileType}
        isMultiple={isMultiple}
        accept={accept}
        onDataLoaded={handlleFileData}
        sampleLinkDownload={handleDownloadLineItemsExcel}
        sampleLinkInfoText={linkInfoText}
      />
      {failureArrayHtml()}
    </Modal>
  );
};

export default SEBulkShipmentHtml;